/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Inventory {

    import fld = SortingDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class SortingDetailsEditor extends _Ext.ItemGridEditor<SortingDetailsRow> {
        Editable() {
            this.slickGrid.getOptions().editable;
        }

        protected getColumnsKey() { return "Inventory.SortingDetails"; }
        protected getDialogType() { return SortingDetailsDialog; }
        protected getLocalTextPrefix() { return SortingDetailsRow.localTextPrefix; }
        protected form: SortingDetailsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number; 
        public TotalItems: number;
        statement: string;

        // #endregion 

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: false });
        }



        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns(); 
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
        
            return columns;
        }

        // #endregion

        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);
            (this.parentDialog as SortingDialog).setAttributes(item, true);
            (this.parentDialog as SortingDialog).form.Pieces.value = item.Pieces;
            (this.parentDialog as SortingDialog).form.Weight.value = item.Weight;
            //(this.parentDialog as SortingDialog).setCommonGridData(item.ItemsDetails);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);


                    });
                    this.view.refresh();
                }

                if (target.hasClass('gen-lot')) {
                    //set items on dialog open 
                    let recordId = item[this.getIdProperty()];//get id
                    //this.editItem(recordId);//set as edit


                    //var id = entityOrId;
                    //var item = this.view.getItemById(recordId);
                    this.createEntityDialog(this.getItemType(), dlg => {
                        var dialog = dlg as Common.GridEditorDialog<SortingDetailsRow>;
                        dialog.onDelete = (opt, callback) => {
                            if (!this.deleteEntity(recordId)) {
                                return;
                            }
                            callback({});
                        };
                        this.transferDialogReadOnly(dialog);
                        dialog.onSave = (opt, callback) => this.save(opt, callback);

                        let slider = new Common.SliderDialog($("<div />"), {
                            initDialog: () => dialog,
                            onDataChangeCallback: () => {
                                this.refresh();
                            }
                        });

                        slider.handleEditorEditItem(this, item);
                    });

                }
                this.view.refresh();


                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }

        //private slider: Common.SliderEditorDialog;

        //protected editItem(entityOrId) {

        //    this.slider = new Common.SliderEditorDialog($("<div />"), {
        //        initDialog: () => new SortingDetailsDialog(),
        //        onDataChangeCallback: () => {
        //            this.refresh();
        //        },
        //        entityOrId: entityOrId,
        //        grid: this, // <==========================================
        //        showNextPreviousButtons: true // <========================
        //    });

        //    this.slider.handleEditItem();
        //}


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    //item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    //item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    //item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    //item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    //item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    //item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    //item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    //item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    //item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    //if (item.WstPer != null) {
                    //    item.WstWt = item.NetWeight * (item.WstPer / 100);
                    //}
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.StockSelectGrid;
           
            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {

                    var length = this.view.getItems().length;
                    if (length > 0) {
                        q.alert('', 'Only one item allowed for sorting', true, 2999);
                        return;
                    }
                    var filters: _Ext.SelectGridFilters = {
                        FilterItems: 7
                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Items",
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                    });


                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                          var orddetails = [];
                       
                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: Stock.StockItemRow) {

                            var ItemDetails = [];
                            var purchase: SortingDetailsRow = {
                                ProductId: value.ProductId,
                                AttributeId: value.AttributeId,
                                Line_No: value.Line_No,
                                SKU: value.SKU,
                                DepartmentId: value.DepartmentId,
                                ProductCode: value.ProductCode,
                                ProductName: value.ProductName,
                                ItemTypeId: value.ItemTypeId,
                                CategoryId: value.CategoryId,
                                ProductTypeId: value.ProductTypeId,
                                SubCategoryId: value.SubCategoryId,

                                UnitRate: value.Rate,
                                //  UnitLabour: LaborRate,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                NetWeight: value.NetWeight,
                                CalcOnId: value.CalcOnId,
                                SieveId: value.SieveId,
                                QualityId: value.QualityId,
                                ShapeId: value.ShapeId,
                                StoneColorId: value.StoneColorId,
                                StoneSizeId: value.StoneSizeId,
                                //BOMDetails: bomdetails,
                                //  LaborDetails: labordetail,
                                CompanyId: value.CompanyId,
                                TransId: value.TransId,
                                RefVoucherId: value.VoucherTypeId,
                                RefTransId: value.TransId,
                                RefTransItemId: value.TransItemId,
                                ItemsDetails: ItemDetails,
                                HasBom: value.HasBom,
                                Hsn: value.HSN,

                                StoneSizeName: value.StoneSizeName,
                                SieveName: value.SieveName,
                                StoneColoreName: value.StoneColoreName,
                                QualityName: value.QualityName,
                                ShapeName: value.ShapeName,
                                BagNo: value.BagNo,
                                LotNo: value.LotNo,
                                Lab: value.Lab,
                                CertificateNo: value.CertificateNo,
                                
                            };
                            orddetails.push(purchase);

                        });
                        for (let orderDetail of orddetails) {
                            orderDetail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(orderDetail);
                            (this.parentDialog as SortingDialog).form.Pieces.value = orderDetail.Pieces;
                            (this.parentDialog as SortingDialog).form.Weight.value = orderDetail.Weight;
                        }
                        
                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            });


            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //btnAdd.onClick = e => { this.addButtonClick(); };

            return buttons;
        }



        // #endregion




        /*
                validateEntity(row, id) {
                    row.P = Q.toId(row.ProductID);
        
                    var sameProduct = Q.tryFirst(this.view.getItems(), x => x.PrdId === row.ProductID);
                    if (sameProduct && this.id(sameProduct) !== id) {
                        Q.alert('This product is already in order details!');
                        return false;
                    }
        
                    return true;
                }*/
    }
}